import React from 'react';
import moment from 'moment';
import { ToBillArguments, ToBillEvent } from '../../../models/Factura';
import Input from '../../Forms/Input';
import { formatCurrencyStyled } from '../../visuals/currency.formatted';
import { conceptoToTotales } from '../../../utils/calculate.conceptos';

interface PreviewPagosProps {
    toBillArgument: ToBillArguments<ToBillEvent>;
    toPaymentEvents: ToBillEvent[];
    // Emitters
    onChangePayment: (eventIndex: number) => (value: number) => void;
    onChangePaymentDate: (eventIndex: number) => (date: Date) => void;
}

function PreviewPagos({ toBillArgument, toPaymentEvents, onChangePayment, onChangePaymentDate }: PreviewPagosProps) {
    if (!toPaymentEvents.length) {
        return null;
    }
    // Runs down the bill total as each parcialidad is applied
    let exerciceTotal = conceptoToTotales(toBillArgument.MasterCFDI.conceptos).total;
    return (
        <div className="pagosWrap">
            <h2>Complementos de pago por parcialidades</h2>
            {
                toPaymentEvents.map((pago, i) => {
                    exerciceTotal -= pago.paymentCFDI.pagos[0].monto;
                    const isLast = (i + 1) === toPaymentEvents.length;
                    const isFirst = i === 0;
                    const exceedsError = isLast && Math.round(Math.abs(exerciceTotal)) > 0;
                    return (
                        <div className="_pago card" key={i}>
                            <div>
                                {
                                    i === 0 && toBillArgument.multipayType === 3 ?
                                        <p>Primera Parcialidad o Anticipo</p>
                                        :
                                        <p>Parcialidad #{i + 1}</p>
                                }
                                <span className={`label ${exceedsError ? 'error' : ''}`}>Saldo pendiente después de pago {formatCurrencyStyled(exerciceTotal)}</span>
                            </div>
                            <Input isCurrency={true} type="number" value={pago.paymentCFDI.pagos[0].monto} label="Monto de parcialidad" onChange={onChangePayment(i)} hasError={exceedsError} />
                            <Input type="date" value={pago.when} label="Fecha esperada" onChange={onChangePaymentDate(i)}
                                max={isLast ? null : moment(toPaymentEvents[i + 1].when).format('YYYY-MM-DD')}
                                min={isFirst ? moment(Date.now()).format('YYYY-MM-DD') : moment(toPaymentEvents[i - 1].when).format('YYYY-MM-DD')} />
                            <div></div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default PreviewPagos;
